module.exports = __webpack_public_path__ + "asset/logoGroup_-M-x9rnQ.png";